import { render, staticRenderFns } from "./PagamentosTabs.vue?vue&type=template&id=74222510"
import script from "./PagamentosTabs.vue?vue&type=script&lang=js"
export * from "./PagamentosTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports